import MuiDialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
export interface DialogTitleProps {
    className?: string;
    children: React.ReactNode;
}
export function DialogTitle({ className, children }: DialogTitleProps) {
    return <MuiDialogTitle className={className}>{children}</MuiDialogTitle>;
}
